import script from "./adBannersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./adBannersView.vue?vue&type=script&lang=ts&setup=true"

import "./adBannersView.vue?vue&type=style&index=0&id=7a904920&lang=scss"

const __exports__ = script;

export default __exports__